import type { ResolutionSummary } from './resource-id'

type Translate = (key: string, options?: Record<string, unknown>) => string

/**
 * Wording for what a pasted id resolved. Two halves: what the picker filled in
 * on its own, then what is left for the user — so a collapsed step never looks
 * like a selection the user made.
 */
export const buildResolutionMessage = (resolution: ResolutionSummary, t: Translate): string => {
    const { collapsedSteps, remainingStep, remainingCount } = resolution

    if (!remainingStep) {
        return collapsedSteps.length > 0
            ? t('formComponents.idHintCompleteCollapsed')
            : t('formComponents.idHintComplete')
    }

    if (remainingCount === 0) {
        return t('formComponents.idHintNoOptions')
    }

    const pick = t(
        remainingStep === 'variant'
            ? 'formComponents.idHintPickVariant'
            : 'formComponents.idHintPickPrice',
        { count: remainingCount },
    )

    return collapsedSteps.length > 0 ? `${t('formComponents.idHintCollapsed')} ${pick}` : pick
}
